// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// SUBSTITUA OS VALORES ABAIXO PELOS QUE O FIREBASE TE MOSTROU
const firebaseConfig = {
  apiKey: "AIzaSyBKOuqeVNLfK6t1TDLcWPxsu_u0DNtfmgk",
  authDomain: "lonjovial.firebaseapp.com",
  projectId: "lonjovial",
  storageBucket: "lonjovial.firebasestorage.app",
  messagingSenderId: "430443380476",
  appId: "1:430443380476:web:2a834ca08bbf7cda41e179"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { auth, db, googleProvider };